import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import moment from 'moment';
import CardHeader from '../../../../components/CardHeader';
import Toast from '../../../../components/Toast';
import TopBarWithShadow from '../../../../components/TopBar/TopBarWithShadow';
import CustomOverLay from '../../../../components/CustomOverlay';
import { dataService } from '../../../../services/data.services';
import { GetBranchId } from '../../../../CommonMethods/GetBranchId';
import { downloadS3Object } from '../../../../CommonMethods/S3DownloadHook';
import { formatAdjustedDate, formatDateTime } from '../../../../CommonMethods/formatDate';

export default function ViewHomework() {
    const { id } = useParams();
    const location = useLocation();
    const [toastErrorMessage, setToastErrorMessage] = useState('');
    const [pageLoading, setPageLoading] = useState(true);
    const [entry, setEntry] = useState(null);

    useEffect(() => {
        const loadEntry = async () => {
            try {
                const branch_id = await GetBranchId();
                const res = await dataService.GetAPI(`notice-board/homework/${id}?branch_id=${branch_id}`);
                setEntry(res.data?.data?.data || null);
            } catch (error) {
                setToastErrorMessage(error?.response?.data?.message || 'Something went wrong while loading');
            } finally {
                setPageLoading(false);
            }
        };

        loadEntry();
    }, [id]);

    const handleAttachmentDownload = async (attachment) => {
        if (!attachment?.key) return;
        try {
            await downloadS3Object(attachment.key);
        } catch {
            setToastErrorMessage('Unable to download attachment');
        }
    };

    const sectionDisplay = entry?.sections?.length > 0
        ? entry.sections.map((section) => section.section_name).join(', ')
        : entry?.section_name || '-';
    const backLocation = location.search
        ? `/noticeboard/classroom${location.search}`
        : '/noticeboard/classroom?type=homework';

    return (
        <CardHeader noPadding>
            <TopBarWithShadow
                Tittle="View Homework"
                isback={true}
                backLocation={backLocation}
            />
            {toastErrorMessage !== '' && (
                <Toast message={toastErrorMessage} type="error" setToastmessage={setToastErrorMessage} />
            )}
            {pageLoading && (
                <CustomOverLay Active text="Loading..." classKey="flex flex-col 
                justify-center items-center sidebarOpenedOverlay" />
            )}
            {!pageLoading && (
                <div className="mainDataCntnrPageDiv scrollBlue_thick">
                    <div className="2xl:w-[65%] w-[80%] mx-auto">
                        <div className="border rounded border-[#D0D5DD]  p-3 mb-6 2xl:w-[70%] xl:w-[85%] m-auto bg-white">
                            <div className="-mx-2 flex w-full">
                                <div className="w-[50%] px-2 " >
                                    <div className="flex mb-3 gap-4">
                                        <span className="w-[110px]" >Academic Year</span>
                                        <span className="font-semibold break-all">{entry?.academic_year_name}</span>
                                    </div>
                                    <div className="flex mb-3 gap-4">
                                        <span className="w-[110px]" >Class</span>
                                        <span className="font-semibold break-all">{entry?.class_name}</span>
                                    </div>
                                    <div className="flex gap-4">
                                        <span className="w-[110px]" >Section</span>
                                        <span className="font-semibold break-all">{sectionDisplay}</span>
                                    </div>
                                </div>
                                <div className="w-[50%] px-2 " >
                                    <div className="flex mb-3 gap-4">
                                        <span className="w-[110px]" >Homework Date</span>
                                        <span className="font-semibold break-all">{formatAdjustedDate(entry?.date) || '-'}</span>
                                    </div>
                                    <div className="flex mb-3 gap-4">
                                        <span className="w-[110px]" >Added Date</span>
                                        <span className="font-semibold break-all">
                                            {formatDateTime(entry?.created_at) || '-'} </span>
                                    </div>
                                    <div className="flex gap-4">
                                        <span className="w-[110px]" >Added by</span>
                                        <span className="font-semibold break-all">{entry?.created_by_name || '-'}</span>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div class='mt-4'> 
                            <table className="w-full morepadding" id="admin-table">
                                <thead className="bg-[#f3f4f6] text-sm font-semibold">
                                    <tr>
                                        <th className="text-left w-[25%]">Subject</th>
                                        <th className="text-left w-[45%]">Homework</th>
                                        <th className="text-left w-[30%]">Attachment</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {(entry?.homeworks || []).map((row, index) => (
                                        <tr key={row.homework_id || index} className="border-t align-top">
                                            <td className="px-2 py-2">{row.subject_name || '-'}</td>
                                            <td className="px-2 py-2 whitespace-pre-wrap">{row.description || '-'}</td>
                                            <td className="px-2 py-2">
                                                {row.attachment?.name ? (
                                                    <button
                                                        type="button"
                                                        className="text-[#106EB4] underline text-left"
                                                        onClick={() => handleAttachmentDownload(row.attachment)}
                                                    >
                                                        {row.attachment.name}
                                                    </button>
                                                ) : '-'}
                                            </td>
                                        </tr>
                                    ))}
                                    {(!entry?.homeworks || entry.homeworks.length === 0) && (
                                        <tr>
                                            <td colSpan="4" className="no-records-message" style={{ lineHeight: '100px' }}>
                                                No homework found.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            )}
        </CardHeader>
    );
}
